function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSalsa = function SvgSalsa(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#7657C1"
    },
    d: "M250.5,22c-135.31,0-245,109.69-245,245c0,94.488,53.496,176.469,131.845,217.344l186.159,16.594   C423.159,469.871,495.5,376.884,495.5,267C495.5,131.69,385.81,22,250.5,22z"
  }), React.createElement("path", {
    style: {
      fill: "#7EC8F2"
    },
    d: "M276.87,343.818c0.55-10.559,1.276-22.144,2.081-27.218c0.289-1.825,0.737-3.615,1.306-5.36   c-10.371-8.147-25.28-13.269-41.87-13.269c-16.815,0-31.905,5.26-42.291,13.601c0.925,2.328,1.594,4.76,1.967,7.265   c0.675,4.527,1.28,14.854,1.753,24.503c0.315,6.425-1.651,12.661-5.412,17.669c10.513,9.32,26.569,15.288,44.581,15.288   c17.454,0,33.068-5.606,43.586-14.433C278.627,356.754,276.527,350.402,276.87,343.818z"
  }), React.createElement("path", {
    style: {
      fill: "#4DADE2"
    },
    d: "M224.062,374.87c0.941-0.658,1.505-0.983,1.505-0.983c13.573-27.428,2.258-74.135,2.258-74.135   c-0.209-0.327-0.407-0.652-0.607-0.977c-12.263,1.762-23.098,6.354-31.121,12.797c0.925,2.328,1.594,4.76,1.967,7.265   c0.675,4.527,1.28,14.854,1.753,24.503c0.315,6.426-1.651,12.661-5.412,17.669C201.903,367.655,212.228,372.582,224.062,374.87z"
  }), React.createElement("path", {
    style: {
      fill: "#474979"
    },
    d: "M278.401,129.683c0,0-1.31,36.364,21.26,52.879c22.57,16.515-12.63,41.393,3.37,51.959   c16,10.566,14.993,48.674-27.559,51.834c-42.551,3.16-67.295-26.639-64.61-52.345c2.685-25.707-29.94-44.415-6.741-107.222   L278.401,129.683z"
  }), React.createElement("path", {
    style: {
      fill: "#3B3F6D"
    },
    d: "M207.446,214.614c24.987,3.169,53.906-9.04,67.743-22.878c11.272-11.272,21.926-8.927,28.955-4.898   c-1.14-1.474-2.609-2.905-4.484-4.277c-13.365-9.78-18.355-26.518-20.204-38.545h-80.625   C190.374,179.207,201.347,198.197,207.446,214.614z"
  }), React.createElement("path", {
    style: {
      fill: "#FCD2AE"
    },
    d: "M504.011,248.223c-5.255-9.381-17.118-12.722-26.498-7.466l-8.956,5.019   c1.3-4.677,2.501-12.513-3.866-12.966c-7.329-0.522-9.822,13.392-10.494,18.56l-77.615,15.093l-84.367-55.65   c-8.976-5.917-21.048-3.442-26.97,5.531c-5.92,8.975-3.443,21.05,5.532,26.97l91.001,60.026c0.263,0.173,0.532,0.327,0.8,0.486   c4.03,2.394,8.667,3.286,13.636,2.373l95.309-18.534c2.082-0.403,4.497-1.303,6.591-2.613l18.432-10.329   C505.925,269.466,509.268,257.602,504.011,248.223z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M192.578,35.28l3.243-4.606c6.189-8.792,4.08-20.936-4.712-27.125   c-8.79-6.186-20.936-4.077-27.125,4.712l-12.202,17.333c-1.319,1.706-2.374,3.654-3.084,5.813   c-0.025,0.076-0.057,0.151-0.082,0.227c-0.021,0.066-0.049,0.127-0.07,0.193l-28.196,92.912c-1.508,4.96-0.859,10.38,1.365,14.651   c57.741,110.581,56.584,106.862,60.654,121.896c1.358-3.272,2.791-5.513,3.358-6.341c1.735-6.129,13.967-16.286,12.736-46.929   c-0.051-1.288,0.409-2.462,1.175-3.372l-39.723-76.205L184.05,48.91c5.336,0.012,19.173-0.659,19.631-7.916   C204.052,35.142,197.393,34.786,192.578,35.28z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M298.032,237.721c4.405-6.674,11.646-10.348,19.08-10.488l-24.896-16.422   c-8.976-5.917-21.048-3.442-26.97,5.531c-5.92,8.975-3.443,21.05,5.532,26.97l25.42,16.768   C293.073,253.047,293.48,244.621,298.032,237.721z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M199.638,204.644l-10.028-19.237c0.538,17.623-18.404,28.673-33.388,20.182   c20.327,38.829,22.439,42.001,26.146,55.698c1.358-3.272,2.791-5.513,3.358-6.341c1.735-6.129,13.967-16.286,12.736-46.929   C198.412,206.727,198.872,205.553,199.638,204.644z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M262.891,208.759c-2.573,0-6.101-2.085-6.101-4.658v-13.626c-3.617,3.163-7.771,5.756-12.303,7.656   c-3.907,1.638-8.383,1.632-12.275,0c-4.619-1.938-8.847-4.594-12.512-7.841v13.811c0,2.573-4.97,4.658-7.543,4.658   c-0.09,0-0.177,0.013-0.267,0.013l2.129,10.412c5.231,16.191,9.834,28.762,16.308,32.301c4.953,2.708,10.873,2.711,15.831,0.003   c6.477-3.538,11.082-16.114,16.316-32.309l2.306-10.328c-0.598-0.056-1.203-0.092-1.816-0.092H262.891z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M239.021,199.325c-2.318,0.097-4.653-0.289-6.809-1.193c-4.619-1.938-8.847-4.594-12.512-7.841   v13.811c0,2.573-4.97,4.658-7.543,4.658c-0.09,0-0.177,0.013-0.267,0.013l2.129,10.412c4.516,13.977,8.566,25.242,13.754,30.342   C239.576,241.466,239.693,212.991,239.021,199.325z"
  }), React.createElement("path", {
    style: {
      fill: "#A0D5FF"
    },
    d: "M196.772,313.467C206.47,304.659,221.477,299,238.335,299c16.723,0,31.627,5.568,41.332,14.255   c1.232-4.739,3.44-9.184,6.641-12.915c20.419-23.794,3.518-46.365,3.518-46.365c-10.038-14.399-11.832-32.547-11.278-46.54   c0.112-2.831-2.135-5.188-4.969-5.188h-4.783c-1.976,0-3.746,1.176-4.548,2.98c-3.999,8.985-10.84,39.015-19.471,43.73   c-4.065,2.219-9.002,2.219-13.065-0.003c-8.628-4.716-15.468-34.744-19.466-43.727c-0.803-1.804-2.574-2.98-4.548-2.98h-4.875   c-2.821,0-5.084,2.309-4.97,5.128c1.24,30.666-10.744,41.986-12.735,46.959c-2.056,3.003-15.512,24.528,4.548,46.898   C192.862,304.798,195.29,308.962,196.772,313.467z"
  }), React.createElement("path", {
    style: {
      fill: "#A0D5FF"
    },
    d: "M312.613,407.578c-7.481-22.603-17.78-34.738-25.533-41.082c-2.438-1.994-4.492-4.353-6.112-6.958   C271.324,368.915,255.822,375,238.335,375c-17.584,0-33.157-6.154-42.789-15.62c-1.802,2.809-4.133,5.298-6.921,7.307   c-23.959,17.265-38.845,53.719-51.312,108.003c-0.665,2.895-1.418,5.71-2.249,8.449C169.462,501.549,208.758,512,250.5,512   c26.318,0,51.659-4.167,75.421-11.847C316.16,463.379,320.069,430.104,312.613,407.578z"
  }), React.createElement("polygon", {
    style: {
      fill: "#474979"
    },
    points: "202.053,131.661 202.053,131.661 202.053,131.661  "
  }), React.createElement("path", {
    style: {
      fill: "#474979"
    },
    d: "M211.926,76.189c11.609-6.258,22.621-3.844,28.786-1.242c8.388-5.674,13.654-5.844,19.35-2.838   c18.628,9.83,23.451,41.122,20.193,59.508l0,0l0,0.006c-1.978-0.085-4.18,0.522-5.608,1.434v0c-0.487-1.71-1.158-3.813-2.098-4.915   c-0.847-0.992-1.366-2.209-1.38-3.5c-0.072-6.837-2.092-26.608-23.341-22.711c-4.062,12.245-15.543,33.543-45.775,29.729l0,0l0,0   c-1.392-0.967-3.569-1.658-5.548-1.649l0-0.006C186.539,119.312,192.298,86.77,211.926,76.189z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M200.674,154.92c0,0-2.32-14.301,0.352-22.818c-2.425-1.574-7.11-2.343-9.217-0.337   c-4.314,4.107-1.153,10.309,0.359,14.227c0.464,1.203,0.764,2.42,0.9,3.639c0.294,2.648,1.769,6.525,7.883,6.434   C200.859,155.683,200.764,155.308,200.674,154.92z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M199.747,143.689c-1.176,0.935-2.662,1.497-4.281,1.497c-1.578,0-3.029-0.536-4.19-1.429   c0.315,0.798,0.629,1.553,0.893,2.236c0.464,1.203,0.764,2.419,0.9,3.638c0.294,2.648,1.769,6.525,7.883,6.434   c-0.092-0.382-0.187-0.757-0.277-1.145C200.674,154.92,199.829,149.699,199.747,143.689z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M284.406,131.765c-2.107-2.006-6.792-1.238-9.217,0.337c2.673,8.517,0.352,22.818,0.352,22.818   c-0.09,0.388-0.185,0.764-0.277,1.145c6.114,0.091,7.589-3.785,7.883-6.434c0.135-1.219,0.435-2.436,0.899-3.639   C285.559,142.075,288.72,135.872,284.406,131.765z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M280.848,145.186c-1.663,0-3.188-0.589-4.379-1.57c-0.075,6.041-0.927,11.304-0.927,11.304   c-0.09,0.388-0.185,0.764-0.277,1.145c6.114,0.091,7.589-3.785,7.883-6.434c0.136-1.219,0.435-2.436,0.9-3.638   c0.252-0.652,0.55-1.372,0.851-2.131C283.76,144.691,282.363,145.186,280.848,145.186z"
  }), React.createElement("path", {
    style: {
      fill: "#FCD2AE"
    },
    d: "M273.173,127.829c-0.889-0.971-1.446-2.172-1.486-3.456c-0.231-7.505-3.207-30.634-31.781-20.014   c-1.123,0.417-2.376,0.417-3.499,0c-28.574-10.62-31.549,12.509-31.781,20.014c-0.039,1.285-0.597,2.486-1.485,3.456   c-5.956,6.508-2.604,27.066-2.604,27.066c2.849,12.188,6.818,21.242,10.823,27.888c4.739,7.863,12.028,13.989,20.672,17.615   c3.883,1.629,8.351,1.635,12.25,0c8.644-3.626,15.933-9.752,20.672-17.615c4.005-6.646,7.974-15.7,10.823-27.888   C275.777,154.895,279.129,134.336,273.173,127.829z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M229.315,182.783c-2.905-6.646-5.784-15.7-7.85-27.888c0,0-2.431-20.559,1.889-27.066   c0.645-0.971,1.049-2.172,1.077-3.456c0.113-5.04,1.132-17.111,8.058-21.292c-24.917-7.138-27.643,14.146-27.863,21.292   c-0.039,1.285-0.597,2.486-1.485,3.456c-5.956,6.508-2.604,27.066-2.604,27.066c2.849,12.188,6.818,21.242,10.823,27.888   c4.739,7.863,12.028,13.989,20.672,17.615c3.883,1.629,8.351,1.635,12.25,0c0.005-0.002,0.01-0.005,0.015-0.007   C238.033,196.765,232.75,190.642,229.315,182.783z"
  }), React.createElement("path", {
    style: {
      fill: "#474979"
    },
    d: "M246.792,73.998c0,0-23.561-23.117-51.024-3.312c-27.463,19.805-16.241,59.84,6.285,60.975   c22.526,1.135,39.148-33.375,57.318-30.349L246.792,73.998z"
  }), React.createElement("path", {
    style: {
      fill: "#3B3F6D"
    },
    d: "M210.334,95.619c0-15.591,10.511-28.375,23.894-29.664c-9.472-4.076-23.377-6.146-38.46,4.73   c-27.463,19.805-16.241,59.84,6.284,60.975c8.219,0.414,15.649-3.923,22.658-9.444C216.185,117.315,210.334,107.249,210.334,95.619   z"
  }), React.createElement("path", {
    style: {
      fill: "#7EC8F2"
    },
    d: "M207.328,435.69c-14-43.292,18.24-61.803,18.24-61.803l0,0   c-12.242-2.177-22.801-7.411-30.021-14.507c-1.802,2.809-4.133,5.298-6.921,7.307c-23.959,17.265-38.845,53.719-51.312,108.003   c-0.665,2.895-1.418,5.71-2.249,8.449c19.581,10.48,40.752,18.376,63.056,23.238C191.053,488.244,217.148,466.057,207.328,435.69z"
  }), React.createElement("path", {
    style: {
      fill: "#7EC8F2"
    },
    d: "M196.772,313.467c7.627-6.926,18.545-11.891,31.056-13.702l-0.003-0.013   c-20.169-31.564,2.152-52.098,2.152-52.098l-0.001-0.006c-7.81-7.404-14.005-34.047-17.732-42.419   c-0.803-1.804-2.574-2.98-4.548-2.98h-4.874c-2.821,0-5.084,2.309-4.97,5.128c1.24,30.666-10.744,41.986-12.735,46.959   c-2.056,3.003-15.511,24.528,4.548,46.898C192.862,304.798,195.29,308.962,196.772,313.467z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSalsa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salsa.910699c6.svg";
export { ForwardRef as ReactComponent };